<template>
 <div  :style="{ height: wrapperHeight + 'px' }" class="wrapper">
  <mt-loadmore :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" distance-inde="10" :auto-fill="false" ref="loadmore">
    <img src="../../assets/img/news-banner.png" width="100%" alt="">
     <ul class="newsList">
      <li v-for="(item,index) in news" :key="index">
        <router-link :to="{path: '/newsdetails?id='+item.newsId }">
          <img :src="item.newsImgUrl" alt="">
          <div>
            <h3>{{item.newsTitle}}</h3>
            <p>{{item.newsDesc}}</p>
            <span>{{item.publishTime}}</span>
          </div>
        </router-link>
      </li>
    </ul>
   </mt-loadmore></div>
</template>
<script>
import { Loadmore } from 'mint-ui';
import Api from '@api/news'
import { setTimeout } from 'timers';
export default {
  name:'newsList',
  components:{Loadmore},
  data(){
    return {
      news:[],
      allLoaded:false,
      wrapperHeight:0,
      page:1,
      pageTotal:1
    }
  },
  created(){

    this.getNewsList()
  
  },
  mounted(){
    let wrapperWight = document.documentElement.clientWidth
    let width = (wrapperWight*60)/750
    this.wrapperHeight = document.documentElement.clientHeight-width
  },
  methods:{
    getNewsList(){
      const params={
        page:this.page,
        tagId:''
      }
      Api.fetchList(params).then(res=>{
        let page = res.data.data.page
        this.pageTotal = page.pageTotal
        this.news = [...this.news,...res.data.data.data]
      })
    },
    loadBottom(){
      if(this.page == this.pageTotal-1){
        this.allLoaded = true; // 最后一页变成true  表示数据加载完毕
      }
      this.page++
      this.getNewsList()
       this.$refs.loadmore.onBottomLoaded();
    },

  }
}
</script>
<style lang="scss">
  .newsList{
    margin-top:50px;
    padding:0 22px;
    // margin-bottom:50px;
    li{
      margin-bottom:50px;
      a{
        display:block;
        width:100%;
        height:100%;
        @include flex;
        font-size:22px;
        color:#666;
        line-height:40px;
      }
      img{
        width:218px;
        height:198px;
        border:1px solid #ccc;
        margin-right:25px;
      }
      div{
        width:457px;
      }
      h3{
        font-size:24px;
        color:#333;
        margin-bottom:10px;
        font-weight: bold;
      }
      p{
        height:120px;
        @include  txt-cut($line:3);
      }
    }
  }
  .wrapper{
    overflow:scroll
  }
</style>


